module.exports = __webpack_public_path__ + "media/images/icons/walk-3f64961a6cb7ab4063210d693b58db88.png";